import { render, staticRenderFns } from "./PlatenumberSelection.vue?vue&type=template&id=82b8fb12&scoped=true"
import script from "./PlatenumberSelection.vue?vue&type=script&lang=js"
export * from "./PlatenumberSelection.vue?vue&type=script&lang=js"
import style0 from "./PlatenumberSelection.vue?vue&type=style&index=0&id=82b8fb12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_qty7iymlffgpukvncpluvycwfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b8fb12",
  null
  
)

export default component.exports